import { render, staticRenderFns } from "./FormulateFishboneDiagram.vue?vue&type=template&id=ab3a0486&scoped=true"
import script from "./FormulateFishboneDiagram.vue?vue&type=script&lang=js"
export * from "./FormulateFishboneDiagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3a0486",
  null
  
)

export default component.exports